import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "../../components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from "../../components/ui/dialog";

interface ForceExitWarningModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
}

function ForceExitWarningModal({ open, onOpenChange, onConfirm }: ForceExitWarningModalProperties) {
  const { t } = useTranslation();

  const handleConfirm = async () => {
    await onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false} className="gap-0 overflow-hidden p-0 sm:max-w-sm">
        <div className="bg-warning text-warning-foreground flex items-center justify-between border-b px-4 py-2">
          <DialogTitle className="text-warning-foreground text-sm font-semibold">
            {t("forceExit.warning.heading", { defaultValue: "CAPS WARNING" })}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t("forceExit.warning.description", {
              defaultValue: "Force exit warning",
            })}
          </DialogDescription>
          <DialogClose className="text-warning-foreground/80 hover:text-warning-foreground p-0.5 transition-colors">
            <X className="size-4.5" />
            <span className="sr-only">{t("forceExit.warning.close", { defaultValue: "Close" })}</span>
          </DialogClose>
        </div>
        <div className="space-y-4 p-4">
          <p className="text-sm">
            {t("forceExit.warning.message", {
              defaultValue:
                "Dealer has canceled the pre-approval request. You will be removed from the deal and the dealer will be notified of any changes that you have already made.",
            })}
          </p>
          <div className="flex justify-end gap-2">
            <Button type="button" size="sm" onClick={() => void handleConfirm()}>
              {t("forceExit.warning.ok", { defaultValue: "OK" })}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ForceExitWarningModal;
